export default {
  // 模块名称
  video: {
    // 按钮类
    button: {
      reset: '重置',
      confirm: '确定',
      cancel: '取消',
      add: '新增',
      cover: '覆盖',
      delete: '删除',
      drag: '拖动',
      edit: '修改',
      addMonitor: '添加监控点',
      manualVideo: '手动录像',
      planVideo: '计划录像',
      warnVideo: '告警录像',
      Search: '查询'
    },
    // 文字标签类
    label: {
      favorites: '收藏夹',
      camera: '摄像机',
      timesSpeed: '倍速',
      number: '序号',
      selectDate: '选择日期',
      startTime: '开始时间',
      endTime: '结束时间',
      HoldingInter: '保持时间间隔',
      storageLocation: '存储位置',
      server: '服务器',
      front: '前端',
      halfHour: '半小时',
      oneHour: '一小时',
      fourHour: '四小时',
      twlHour: '12小时',
      dobHour: '24小时',
      thrDay: '3天',
      oneWeek: '一周',
      muchday: '30天',
      camerName: '摄像机名称',
      videoStart: '录像开始时间',
      videoEnd: '录像结束时间',
      operation: '操作',
      progress: '进度条',
      status: '状态',
      speed: '下载速度',
      lastTime: '剩余时间',
      loadPath: '下载路径',
      uploadTime: '选择下载时间',
      anyTime: '任意时间点',
      whetherAcross: '是否跨天',
      yes: '是',
      no: '否',
      download: '下载',
      finish: '已完成',
      downSucc: '录像下载完成',
      showScene: '显示保存场景',
      init: '正在初始化...',
      pleaseDown: '未检测到电脑中含有ActiveX OCX控件, 请先下载OCX控件. ',
      clickBtn: '点击下载',
      supportIe: '对不起，当前控件只支持IE浏览器',
      getVideo: '正在获取视频信息...',
      fullScreen: '全屏',
      playVideo: '播放',
      capture: '抓拍',
      a: '个',
      addFavorite: '添加到收藏夹',
      addFavoritea: '收藏',
      selected: '已选',
      isAdd: '已收藏',
      newAdd: '新建收藏夹',
      reduceScale: '缩小刻度',
      enlargeScale: '放大刻度',
      windows: '窗口',
      hours: '小时',
      msgInfo1: '下载的时间范围不能小于1秒',
      list: '暂无数据，如有需要请新建',
      loading: '正在加载中...'
    },
    // 提示类
    placeholder: {
      selectStartTime: '请选择起始时间',
      selectEndTime: '请选择结束时间',
      selectKeepTime: '请选择时间间隔',
      selectKeepLoca: '请选择存储位置',
      selectVideoType: '请选择录像类型',
      compareEndTime: '开始时间不能大于结束时间',
      selectTimeLen: '录像查询时间范围不能超过30天',
      addOrSeachFavorite: '搜索/创建收藏夹',
      name: '请输入名称',
      pleaseSelect: '请选择'
    },
    // 消息类
    message: {
      deleteWarn: '是否确认删除当前预置位？',
      disableEmpty: '预置位名称不可为空',
      disableInclude: '任务名称不能包含特殊字符',
      disableMore: '预置位名称不可超过20个字符！',
      coverWarn: '是否确认覆盖当前场景？',
      deleteSceneWarn: '是否确认删除当前场景？',
      deleteOk: '删除成功',
      disableNameEmpty: '场景名称不可为空',
      disableNameMore: '场景名称不可超过20个字符！',
      deleteNameWarn: '是否确认删除当前选中节点？',
      disableFlodEmpty: '文件夹名称不可为空',
      disableFlodMore: '文件夹名称不可超过50个字符！',
      disableFlodReg: '文件夹名称只允许输入汉字、字母和数字！',
      canOperate: '仅实时视频可操作云台控制！',
      canAddOperate: '仅球机可添加预置位！',
      selectCamera: '请先选择摄像机设备',
      selectWindow: '请先选择窗口',
      chooseCamera: '最多选择4个摄像头',
      addOk: '新增成功',
      coverOk: '覆盖成功',
      noSearchCamer: '没有检索到摄像机{deviceName}的录像',
      video: '的录像!',
      noSearchVideo: '没有检索到录像!',
      cancelOk: '取消成功',
      videoStart: '已经开始录像',
      camer: '摄像机',
      pleaseStop: '已经开始录像，请先停止！',
      startvideoS: '请开始录像',
      pleaseStart: '还未开始录像，请先开始！',
      noVideo: '无信号源！',
      setOk: '收藏成功',
      laterTry: '上一动作尚未完成，请稍后再试！',
      deviceNo: '设备不在线！',
      newSucc: '新建成功'
    },
    // 标题类
    title: {
      cameraList: '摄像机列表',
      favorites: '收藏夹',
      yuntaiControl: '云台控制',
      scopeLarge: '范围放大',
      scopeSmalle: '范围缩小',
      apertureSmalle: '光圈缩小',
      apertureLarge: '光圈放大',
      focusNearly: '聚焦近',
      focusFar: '聚焦远',
      setPreset: '设置预置位',
      searchPreset: '查询预置位',
      addPreset: '添加预置位',
      delPreset: '删除预置位',
      callPreset: '调用预置位',
      call: '调用',
      presetName: '预置位名称',
      fullScreen: '全屏',
      video: '录像',
      stopVideo: '停止录像',
      localSnap: '本地抓拍',
      snapList: '一键抓拍',
      platSnap: '平台抓拍',
      stop: '关闭所有',
      oneScreen: '一分屏',
      fourScreen: '四分屏',
      sixScreen: '六分屏',
      nineScreen: '九分屏',
      sceneCollect: '场景收藏',
      sceneName: '场景名称',
      addScene: '新增场景',
      coverScene: '覆盖场景',
      delScene: '删除场景',
      cameraCollect: '摄像机收藏',
      newfolder: '新建文件夹',
      newfolderName: '新建文件夹名称',
      delFavFolder: '删除文件夹收藏',
      videoSearch: '录像搜索',
      videoUpload: '录像下载',
      selectedCamera: '已选摄像机',
      back: '快退',
      play: '播放',
      fast: '快进',
      stopPlay: '暂停',
      switch: '切换下载列表'
    }
  }
}
